// Copyright (c) 2023 Deere & Company

import Form from './pin-plate-form';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.duplicatePinPlateRequest,
    security: state.user.security,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(Form);



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/duplicate-pin-plate-form/index.js